(function () {
  if (window.__hwParallaxScrollInit) return;
  window.__hwParallaxScrollInit = true;

  var WRAPPER_CLASS = 'hw-parallax-wrapper';
  var PREV_CLASS = 'hw-parallax-prev';
  var CURRENT_CLASS = 'hw-parallax-section';

  function wrapPair(container) {
    // Already wrapped
    if (container.parentNode && container.parentNode.classList &&
        container.parentNode.classList.contains(WRAPPER_CLASS)) {
      return container.parentNode;
    }

    var prev = container.previousElementSibling;
    if (!prev) return null;

    var wrapper = document.createElement('div');
    wrapper.className = WRAPPER_CLASS;

    var parent = container.parentNode;
    parent.insertBefore(wrapper, prev);
    wrapper.appendChild(prev);
    wrapper.appendChild(container);

    prev.classList.add(PREV_CLASS);
    container.classList.add(CURRENT_CLASS);

    return wrapper;
  }

  function initSection(el) {
    var container = el.closest('.shopify-section') || el;
    var wrapper = wrapPair(container);
    if (!wrapper) return null;
    return { el: el, container: container, wrapper: wrapper };
  }

  var pairs = [];
  var ticking = false;

  function update() {
    pairs.forEach(function (pair) {
      if (!pair) return;
      var rect = pair.container.getBoundingClientRect();
      if (rect.top <= 0 && rect.bottom > 0) {
        pair.el.classList.add('top-reached');
      } else {
        pair.el.classList.remove('top-reached');
      }
    });
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  function scanAndInit() {
    var elements = document.querySelectorAll('[data-hw-parallax]');
    pairs = [];
    elements.forEach(function (el) {
      var pair = initSection(el);
      if (pair) pairs.push(pair);
    });
    update();
  }

  function ready() {
    scanAndInit();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // Re-run when a section is added/updated in the theme editor
    document.addEventListener('shopify:section:load', scanAndInit);
    document.addEventListener('shopify:section:unload', scanAndInit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
